import React from 'react';

import Tile from 'ibis-design-system/lib/components/core/Tile';
import AppLogo from 'ibis-design-system/lib/components/core/AppLogo';

const getSize = variant =>
    ({
        medium: [50, 50],
        large: [100, 50]
    }[variant]);

const getIconSize = variant =>
    ({
        medium: 50,
        large: 100
    }[variant]);


const getColors = (variant) => {
    if (variant === "error") {
        return {
            background: "#FF3300",
            hover: "#e52d00",
            text: "black",
            selected: "#b32400",
        };
    }

    return {
        background: "rgba(255, 255, 255, 0.15)",
        hover: "rgba(255, 255, 255, 0.25)",
        selected: "rgba(255, 255, 255, 0.35)",
        text: "white"
    };
}

const ApplicationTile = ({ variant, size, icon, selected, children }) => {
    const colors = getColors(variant);
    const background = (selected === true) ? colors.selected : colors.background;
    return (
        <Tile
            backgroundColor={background}
            hoverColor={colors.hover}
            headerSize={getSize(size)[0]}
            SubTextSize={getSize(size)[1]}
            color={colors.text}
        >
            <Tile.Head>
                <AppLogo
                    name={icon}
                    width={getIconSize(size)}
                    fill={colors.text}
                />
            </Tile.Head>
            <Tile.SubText>{children}</Tile.SubText>
        </Tile>
    );
}



export default ApplicationTile;
